<template>
  <div class="camp-frame">
    <div class="camp-bar">
      <span class="camp-back" @click="goBack">返回</span>
      <span class="camp-title">{{ title }}</span>
    </div>
    <p class="camp-desc">{{ desc }}</p>
    <slot></slot>
    <div class="camp-links" v-if="links && links.length">
      <div
        class="camp-btn"
        v-for="item in links"
        :key="item.path"
        @click="go(item.path)"
      >{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampFrame',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    links: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    // 进入指定页面
    go (path) {
      this.$router.push(path)
    },
    // 返回上一页
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.camp-frame {
  min-height: 100vh;
  padding: 16px 16px 32px;
  box-sizing: border-box;
  background: #F9F8F7;
}

.camp-bar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.camp-back {
  font-size: 14px;
  color: #EB1700;
  margin-right: 12px;
}

.camp-title {
  font-size: 18px;
  font-weight: 600;
  color: #282828;
}

.camp-desc {
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 22px;
  color: #666;
}

.camp-links {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
}

.camp-btn {
  margin: 0 8px 8px 0;
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
  background: #EB1700;
  color: #fff;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampFrame.vue